// EcoRain - Toon meer + Swiper tabs v3 - auto-width tabs op alle mobile/tablet sizes

(function() {
  var PAGE_SIZE = 12;

  function initLoadMore() {
    var items = document.querySelectorAll('.content.product-content');
    var button = document.getElementById('loadMore');
    var uspBlocks = document.querySelectorAll('.custom-usp-contents');
    if (!button) return;
    if (items.length <= PAGE_SIZE) {
      for (var i = 0; i < items.length; i++) items[i].style.display = '';
      button.style.display = 'none';
      return;
    }
    var visibleCount = PAGE_SIZE;
    for (var j = 0; j < items.length; j++) {
      items[j].style.display = j < PAGE_SIZE ? '' : 'none';
    }
    button.style.display = '';
    var uspIndex = 0;
    if (uspBlocks[uspIndex]) uspBlocks[uspIndex].classList.add('flex');
    var fresh = button.cloneNode(true);
    button.parentNode.replaceChild(fresh, button);
    button = fresh;
    button.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      uspIndex++;
      if (uspBlocks[uspIndex]) uspBlocks[uspIndex].classList.add('flexs');
      var shown = 0;
      for (var k = 0; k < items.length && shown < PAGE_SIZE; k++) {
        if (items[k].style.display === 'none') {
          items[k].style.display = '';
          shown++;
          visibleCount++;
        }
      }
      if (visibleCount >= items.length) button.style.display = 'none';
      return false;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLoadMore);
  } else {
    initLoadMore();
  }

  window.checkboxChange = function() { setTimeout(initLoadMore, 1500); };
})();

(function ensureAutoWidthCss() {
  if (document.getElementById('ec-tabs-autowidth-css')) return;
  var s = document.createElement('style');
  s.id = 'ec-tabs-autowidth-css';
  s.textContent = '.collection-tabs-box .swiper-slide { width: auto !important; flex-shrink: 0 !important; } .collection-tabs-box .custom-collection-value { width: auto !important; padding: 8px 18px !important; white-space: nowrap !important; }';
  document.head.appendChild(s);
})();

if (typeof Swiper !== 'undefined') {
  new Swiper('.collection-tabs-box', {
    loop: false,
    slidesPerView: 'auto',
    spaceBetween: 10,
    freeMode: true,
    paginationClickable: true,
    pagination: { el: '.swiper-pagination' }
  });
}
